(() => {
  const namespace = '__ccHappyCustomers';
  const rootSelector = '[data-cc-happy-customers]';

  const initializeRoot = (root) => {
    if (root.dataset.ccHappyCustomersReady === 'true') return;

    const buttons = Array.from(root.querySelectorAll('[data-cc-filter]'));
    const cards = Array.from(root.querySelectorAll('[data-cc-card]'));
    const resultCount = root.querySelector('[data-cc-result-count]');

    if (!buttons.length || !cards.length || !resultCount) return;

    const applyFilter = (filter) => {
      let visibleCount = 0;

      cards.forEach((card) => {
        const visible = filter === 'all' || card.dataset.ccCategory === filter;
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      buttons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.ccFilter === filter));
      });

      if (filter === 'outdoor') {
        resultCount.textContent = `Showing ${visibleCount} field wear looks`;
      } else if (filter === 'custom') {
        resultCount.textContent = `Showing ${visibleCount} custom print looks`;
      } else {
        resultCount.textContent = `Showing all ${visibleCount} looks`;
      }
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => applyFilter(button.dataset.ccFilter));
    });

    root.dataset.ccHappyCustomersReady = 'true';
  };

  const initialize = (scope) => {
    if (scope.matches && scope.matches(rootSelector)) initializeRoot(scope);
    scope.querySelectorAll(rootSelector).forEach(initializeRoot);
  };

  if (window[namespace]) {
    window[namespace].initialize(document);
    return;
  }

  window[namespace] = { initialize };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
